import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPropAgitator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 88.4,
	viewBox: "0 0 20.0 88.4",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 16.0 2.4 L 16.0 27.4 A 5.0 2.0 0.0 0 1 4.0 27.4 L 4.0 2.4 A 5.0 2.0 0.0 0 1 16.0 2.4 Z M 4.0 2.4 L 16.0 2.4 M 4.0 27.4 L 16.0 27.4",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 29.9,
			width: 2,
			height: 57.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 15,
			cy: 87.4,
			rx: 5,
			ry: 1,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 5,
			cy: 87.4,
			rx: 5,
			ry: 1,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgPropAgitator;
